import { render, staticRenderFns } from "./supplierAdmin.vue?vue&type=template&id=2ce7c40c&"
import script from "./supplierAdmin.vue?vue&type=script&lang=js&"
export * from "./supplierAdmin.vue?vue&type=script&lang=js&"
import style0 from "./supplierAdmin.vue?vue&type=style&index=0&id=2ce7c40c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports